import { render, staticRenderFns } from "./DroppableImageSelector.vue?vue&type=template&id=09ff3ace"
import script from "./DroppableImageSelector.vue?vue&type=script&lang=js"
export * from "./DroppableImageSelector.vue?vue&type=script&lang=js"
import style0 from "./DroppableImageSelector.vue?vue&type=style&index=0&id=09ff3ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports